// src/pages/dashboard/components/DashboardLayout.js
import React from 'react'
import PropTypes from 'prop-types'
import { Helmet } from 'react-helmet'
import { Box, Container, Button, Footer } from '@allied-solutions/affinity'
import { Layout, Nav } from '../../components'
import { useWindowWidth } from '../../hooks/'
import { theme } from '../../theme'
import { navigate } from 'gatsby'

export const DashboardLayout = ({
  children,
  metaTitle,
  metaDescription,
  isBorrowerError,
}) => {
  const windowWidth = useWindowWidth()
  const isMobile = windowWidth < parseInt(theme.breakpoints[1])
  const showMobileFooter = isMobile && !isBorrowerError
  return (
    <Layout>
      <Helmet>
        <title>{metaTitle}</title>
        <meta name="description" content={metaDescription} />
      </Helmet>
      <Nav underlineHome />
      <Box
        as="main"
        backgroundColor="background.brandMuted"
        minHeight="100vh"
        width="100%"
        pb="4xl"
        px={[3, 0]}
      >
        <Container>{children}</Container>
      </Box>
      {showMobileFooter && (
        <Footer
          as="footer"
          backgroundColor="white"
          width="100%"
          p="4xl"
          position="fixed"
          bottom={0}
          left={0}
          right={0}
          zIndex={99}
          borderTop="1px solid"
          borderColor="gray90"
          boxShadow="0 -10px 25px 0 rgba(0, 112, 185, 0.06)"
        >
          <Button
            id="Dashboard__Layout__Footer__Button--enter-reference-id"
            minWidth="100%"
            size="md"
            onClick={() => {
              navigate('/enter-reference-id/')
            }}
          >
            Enter Reference ID
          </Button>
        </Footer>
      )}
    </Layout>
  )
}

DashboardLayout.propTypes = {
  children: PropTypes.node.isRequired,
  metaTitle: PropTypes.string.isRequired,
  metaDescription: PropTypes.string.isRequired,
  isBorrowerError: PropTypes.bool,
}
